import React, { useEffect, useState } from 'react';
import ErrorMessage from '../../Elements/ErrorMessage';
import Loading from '../../Elements/loading';
import FaIcon from '../../Elements/FaIcon';
import NotificationService from '../../Services/NotificationService';
import AuthService from '../../Services/authService';
import OneMessage from './OneMessage';
import ShownPanelsEnum from '../../Enums/ShownPanelsEnum';
import GeneralEditWizzardBase from '../../Elements/GeneralEditWizzard/GeneralEditWizzardBaseFigma';
import CrudTypesEnum from '../../Enums/CrudTypesEnum';
import MessageItem from '../../Domain/MessageItem';
import NewMessagePanelDescription from './NewMessagePanelDescription';
import BravoListPage from '../../Elements/BravoListPage';
import AccountBreadcrumbLink from '../../Elements/AccountBreadcrumbLink';

function Messages() {
  const [loading, setLoading] = useState(true);
  const [messages, setMessages] = useState([]);
  const [overlayWindow, setOverlayWindow] = useState(null);

  const populateData = () => {
    NotificationService.GetMessageList()
      .then((result) => {
        setMessages(result);
        setLoading(false);
      })
      .catch(() => ErrorMessage.SetErrorMessage('M35'));
  };

  useEffect(() => {
    populateData();
  }, []);

  const onDeleteHandler = (id) => {
    setLoading(true);
    NotificationService.DeleteMessageById(id)
      .then(() => populateData())
      .catch(() => ErrorMessage.SetErrorMessage('M42'));
  };

  const showPanel = (shownPanel) => {
    if (shownPanel === ShownPanelsEnum.Refresh) {
      setLoading(true);
      populateData();
    } else if (shownPanel === ShownPanelsEnum.AddNewItem) {
      setOverlayWindow(
        <GeneralEditWizzardBase
          crudType={CrudTypesEnum.Create}
          editedItem={new MessageItem()}
          windowDescription={NewMessagePanelDescription}
          clickOnCancel={() => setOverlayWindow(null)}
          clickOnSave={() => setOverlayWindow(null)}
          errorCode='NMW'
        />
      );
    } else if (shownPanel === ShownPanelsEnum.MassStatusUpdate) {
      NotificationService.MarkAllAsRead()
        .then(() => populateData())
        .catch(() => ErrorMessage.SetErrorMessage('M55'));
    } else if (shownPanel === ShownPanelsEnum.Delete) {
      NotificationService.DeleteAllRead()
        .then(() => populateData())
        .catch(() => ErrorMessage.SetErrorMessage('M55'));
    }
  };

  if (loading) return <Loading />;

  const userName = AuthService.getInstance().GetLoggedInUser()?.userName || '';
  const unreadCount = messages.filter((m) => !m.isRead).length;

  return (
    <BravoListPage
      headerActions={
        <>
          <button type='button' className='btn' onClick={() => showPanel(ShownPanelsEnum.MassStatusUpdate)}>
            <FaIcon iconName='fa-solid fa-check-double' /> Mark all as read
          </button>
          <button type='button' className='btn' onClick={() => showPanel(ShownPanelsEnum.Delete)}>
            <FaIcon iconName='fa-regular fa-trash-can' /> Delete all read
          </button>
          <button type='button' className='btn primary' onClick={() => showPanel(ShownPanelsEnum.AddNewItem)}>
            <FaIcon iconName='fa-solid fa-envelope' /> New message
          </button>
        </>
      }
      breadcrumb={
        <>
          <AccountBreadcrumbLink />
          <FaIcon iconName='fa-solid fa-chevron-right' />
          <span>Messages</span>
        </>
      }
      chip={
        <span className='chip'>
          Mailbox <b>{userName}</b>
        </span>
      }
      countPill={
        <span className='count-pill'>
          <b>{unreadCount}</b> unread
        </span>
      }
      toolbarActions={
        <button type='button' className='icon-btn' title='Refresh' onClick={() => showPanel(ShownPanelsEnum.Refresh)}>
          <FaIcon iconName='fa-solid fa-rotate-right' />
        </button>
      }
      isEmpty={messages.length === 0}
      emptyState={{ icon: 'fa-regular fa-envelope-open', title: 'No messages', subtitle: "You're all caught up." }}
      overlay={overlayWindow}
    >
      {messages.map((message) => (
        <OneMessage message={message} key={'mesk' + message.notificationId} onDelete={onDeleteHandler} />
      ))}
    </BravoListPage>
  );
}

export default Messages;
